import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Rows carry their own status so that every row is filterable, including ones that
  // render an Activate button instead of a checkbox. Toggling a checkbox has to keep
  // that in step, or the next filter would compare against the state as first rendered.
  syncRowStatus(event){
    const row = event.target.closest('tr')
    if (!row) { return }

    row.dataset.status = event.target.checked
  }

  render(){
    this.element.querySelectorAll('tbody tr').forEach((row) => {
      row.hidden = row.dataset.filters
    })

    this.element.querySelectorAll('thead').forEach((thead) => {
      const tbody = thead.nextElementSibling
      const visibleRows = tbody.querySelectorAll('tr:not([hidden])')

      tbody.hidden = thead.hidden = visibleRows.length === 0
    })
  }
}
